function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./Azure"));
__export(require("./Emerald"));
__export(require("./Crimson"));
//# sourceMappingURL=index.js.map